<div class="header-container">
  <label class="header-text" [innerText]="getHeader()"></label>
  <div class="back-to-scheduler-container">
    <a
      class="rounded-btn-prev"
      role="button"
      routerLink="/mam/uploadReport"
    ></a>
    <span class="back">BACK TO MAM</span>
  </div>
</div>
<div *ngIf="liveFeed" class="main-container">
  <form #liveFeedForm="ngForm">
    <div>
      <label
        class="main-container-left-side-header row"
        [innerText]="getTitle()"
      ></label>
      <div class="columns">
        <div class="column-left">
          <div class="row">
            <label>FEED NAME</label>
            <div class="row-input">
              <input
                type="text"
                placeholder="Type your feed name"
                name="name"
                [ngModel]="liveFeed.name"
                (ngModelChange)="onFeedNameChanged($event)"
                required
                #name="ngModel"
              />
              <div
                class="row-input-text error"
                *ngIf="name.invalid && (name.dirty || name.touched)"
              >
                Feed name is required
              </div>
            </div>
          </div>
          <div class="row">
            <label>FEED ID</label>

            <div class="row-input">
              <input
                #tenantUniqueIdElement
                type="text"
                class="tenantUniqueId"
                placeholder="Type Feed Id"
                name="tenantUniqueId"
                [(ngModel)]="liveFeed.tenantUniqueId"
                required
                #tenantUniqueId="ngModel"
              />
              <a
                class="btn btn-copy"
                [class.disabled]="!liveFeed.tenantUniqueId"
                (click)="
                  !!liveFeed.tenantUniqueId &&
                    copyToClipboard(
                      liveFeed.tenantUniqueId,
                      $event,
                      'tenantUniqueId'
                    )
                "
                >Copy</a
              >
              <circle-indicator
                *ngIf="
                  !!liveFeed.tenantUniqueId &&
                  (tenantUniqueId.dirty || tenantUniqueId.touched)
                "
                [status]="feedIdUniqueStatus | async"
              ></circle-indicator>
              <div
                class="row-input-text error"
                *ngIf="
                  tenantUniqueId.invalid &&
                  (tenantUniqueId.dirty || tenantUniqueId.touched)
                "
              >
                Feed Id is required
              </div>
            </div>
          </div>

          <div class="input-group">
            <label>FRAME FORMAT:</label>
            <icn-dropdown [(selectedValue)]="liveFeed.frameFormat">
              <icn-dropdown-item
                *ngFor="let format of frameFormats"
                [value]="format.value"
                [title]="format.displayName"
              >
              </icn-dropdown-item>
            </icn-dropdown>
          </div>

          <div class="row">
            <label>INTERNAL LATENCY MS</label>
            <div class="row-input">
              <icn-number-input
                [min]="0"
                [max]="10000000000000"
                [step]="1"
                [useDefaultHtmlInput]="true"
                [(value)]="liveFeed.internalLatencyMs"
              ></icn-number-input>
            </div>
          </div>

          <div class="row">
            <label>TOTAL LATENCY MS</label>
            <div class="row-input">
              <icn-number-input
                [min]="0"
                [max]="10000000000000"
                [step]="1"
                [useDefaultHtmlInput]="true"
                [(value)]="liveFeed.totalLatencyMs"
              ></icn-number-input>
            </div>
          </div>

          <div class="input-group">
            <label>CHOOSE ZONES:</label>
            <icn-dropdown
              [allowMultiple]="true"
              [selectedValues]="liveFeed.streamingPlatforms"
              (selectedValuesChange)="onPlatformsDropdownChange($event)"
              [equalFunc]="platformsEqualsFunc"
            >
              <icn-dropdown-item
                *ngFor="let platform of allStreamingPlatforms"
                [value]="platform"
                [title]="platform.availabilityZoneName"
              >
              </icn-dropdown-item>
            </icn-dropdown>
            <label
              class="encryption-key-error"
              *ngIf="hasStreamingPlatforms(liveFeed) === false"
              >Please choose at least one platform</label
            >
          </div>
        </div>
      </div>

      <div
        class="platform-tabs-container"
        *ngIf="liveFeed.streamingPlatforms.length > 0"
      >
        <aside class="platform-tabs">
          <button
            type="button"
            *ngFor="let p of liveFeed.streamingPlatforms; let i = index"
            class="platform-tab"
            [class.active]="i === selectedPlatformIndex"
            (click)="selectPlatform(i)"
          >
            {{ p.availabilityZoneName }}
          </button>
        </aside>
        <section class="platform-pane" *ngIf="getActiveSettings() as s">
          <div class="platform-settings">
          <div class="row">
            <label>CHOOSE TYPE</label>
            <div class="row-input">
              <icn-dropdown
                [position]="'bottom'"
                [allowMultiple]="false"
                [(selectedValue)]="s.sourceType"
                (selectedValueChange)="onSourceTypeChanged()"
              >
                <icn-dropdown-item
                  *ngFor="let type of allStreamingSourceTypes"
                  [value]="type.id"
                  [title]="type.displayName"
                >
                </icn-dropdown-item>
              </icn-dropdown>
            </div>
          </div>

          <div class="row" *ngIf="showUsernameField(s.sourceType)">
            <label>USERNAME</label>
            <div class="row-input">
              <input
                type="text"
                placeholder="Type your stream username"
                [ngModel]="s.username"
                (ngModelChange)="s.username = $event; copiedInput = ''"
                name="username"
                #username="ngModel"
              />
            </div>
          </div>

          <div class="row" *ngIf="showPasswordField(s.sourceType)">
            <label>PASSWORD</label>
            <div class="row-input">
              <input
                type="text"
                placeholder="Type your stream password"
                [ngModel]="s.password"
                (ngModelChange)="s.password = $event; copiedInput = ''"
                name="password"
                #password="ngModel"
              />
              <a
                class="btn btn-copy"
                [class.disabled]="!s.password"
                (click)="copyToClipboard(s.password, $event, 'password')"
                >Copy</a
              >
              <div class="row-input-text" *ngIf="copiedInput === 'password'">
                Paste the password into the feeder/broadcaster/app
              </div>
            </div>
          </div>

          <div class="row" *ngIf="showWhitelistIpRangesField(s.sourceType)">
            <label>WHITELIST IP RANGES</label>
            <div class="row-input whitelist-ip-input">
              <div
                class="whitelist-ip-chips"
                *ngIf="s.whitelistIpRanges?.length"
              >
                <div
                  class="whitelist-ip-chip"
                  *ngFor="let range of s.whitelistIpRanges"
                >
                  <span class="chip-label">{{ range }}</span>
                  <button
                    type="button"
                    class="chip-remove"
                    (click)="removeWhitelistIpRange(s, range)"
                  >
                    ×
                  </button>
                </div>
              </div>
              <input
                type="text"
                placeholder="e.g. 213.57.118.227/24"
                [ngModel]="whitelistIpInput"
                (ngModelChange)="onWhitelistIpInputChange($event)"
                [ngModelOptions]="{ standalone: true }"
                (keydown.enter)="
                  $event.preventDefault(); addWhitelistIpRange(s)
                "
              />
              <a class="btn btn-copy" (click)="addWhitelistIpRange(s)">Add</a>
              <label class="encryption-key-error" *ngIf="whitelistIpError">{{
                whitelistIpError
              }}</label>
            </div>
          </div>

          <div class="row">
            <label>PROTOCOL LATENCY MS</label>
            <div class="row-input">
              <icn-number-input
                [min]="0"
                [max]="10000000000000"
                [step]="1"
                [useDefaultHtmlInput]="true"
                [(value)]="s.protocolLatencyMs"
              ></icn-number-input>
            </div>
          </div>

          <div class="small-container" *ngIf="showEncryptionField(s.sourceType)">
            <div
              (click)="toggleEnableEncryption($event)"
              class="checkbox-input"
              [class.active]="s.encryptionType !== 0"
            >
              <div>
                <svg viewBox="0 0 21.02 14.02">
                  <path
                    fill-rule="evenodd"
                    d="M21.498,2.349 L8.886,14.965 L0.479,6.555 L1.880,5.153 L8.886,12.161 L20.096,0.948 L21.498,2.349 Z"
                  />
                </svg>
              </div>
            </div>
            <span class="label-subs"> Enable encryption </span>
            <div
              #enableEncryptionCog
              class="settingIcon"
              (click)="
                s.encryptionType > 0 && encryptionPopover.show($event)
              "
              inlineSVG="/assets/icons/pop-edit.svg"
            ></div>
            <div
              class="encryption-key-error"
              *ngIf="
                !encryptionPopoverVisible &&
                s.encryptionType !== 0 &&
                !s.encryptionKey
              "
            >
              Encryption key is required
            </div>
          </div>

          <div class="row" *ngIf="showUrlField(s.sourceType)">
            <label>URL</label>
            <div class="row-input">
              <input
                type="text"
                class="streamUrl"
                placeholder="Type URL"
                name="streamUrl"
                [(ngModel)]="s.url"
                required
                #streamUrl="ngModel"
              />
              <div
                class="row-input-text error"
                *ngIf="
                  streamUrl.invalid && (streamUrl.dirty || streamUrl.touched)
                "
              >
                Stream Url name is required
              </div>
            </div>
          </div>

          <div class="row" *ngIf="showStreamNameField(s.sourceType)">
            <label>STREAM NAME</label>
            <span class="stream-id-prefix" *ngIf="showLivePrefix(s.sourceType)"
              >live_</span
            >
            <div class="row-input">
              <input
                type="text"
                class="streamName"
                placeholder="Type Stream Name"
                name="streamName"
                [ngModel]="s.streamName"
                (ngModelChange)="onStreamIdChanged($event)"
                required
                #streamName="ngModel"
              />
              <a
                class="btn btn-copy"
                [class.disabled]="!s.streamName"
                (click)="
                  !!s.streamName &&
                    copyToClipboard(
                      'live_' + s.streamName,
                      $event,
                      'streamName'
                    )
                "
                >Copy</a
              >
              <circle-indicator
                *ngIf="
                  !!s.streamName &&
                  (streamName.dirty || streamName.touched)
                "
                [status]="streamIdUniqueStatus | async"
              ></circle-indicator>
              <div
                class="row-input-text error"
                *ngIf="
                  streamName.invalid && (streamName.dirty || streamName.touched)
                "
              >
                Stream Name name is required
              </div>
            </div>
          </div>

          <div class="row" *ngIf="showRemoteAddressField(s.sourceType)">
            <label>REMOTE ADDRESS</label>
            <div class="row-input">
              <input
                type="text"
                class="remoteAddress"
                placeholder="Type Remote Address"
                name="remoteAddress"
                [(ngModel)]="s.remoteAddress"
                required
                #remoteAddress="ngModel"
              />

              <div
                class="row-input-text error"
                *ngIf="
                  remoteAddress.invalid &&
                  (remoteAddress.dirty || remoteAddress.touched)
                "
              >
                Remote Address is required
              </div>
            </div>
          </div>

          <div class="row" *ngIf="showRemotePortField(s.sourceType)">
            <label>REMOTE PORT</label>
            <div class="row-input">
              <icn-number-input
                [min]="0"
                [max]="65535"
                [step]="1"
                [useDefaultHtmlInput]="true"
                [(value)]="s.remotePort"
              ></icn-number-input>
            </div>
          </div>

          <div class="row" *ngIf="showLocalPortField(s.sourceType)">
            <label>LOCAL PORT</label>
            <div class="row-input">
              <div *ngIf="s.localPort !== 0">
                <icn-number-input
                  class="display-inline"
                  [contentEditable]="false"
                  [step]="1"
                  [useDefaultHtmlInput]="true"
                  [(value)]="s.localPort"
                ></icn-number-input>
                <a
                  class="btn btn-copy"
                  [class.disabled]="!s.localPort"
                  (click)="
                    copyToClipboard(s.localPort, $event, 'streamLocalPort')
                  "
                  >Copy</a
                >
              </div>
              <div *ngIf="s.localPort === 0">
                <label class="local-port-will-assigned-lbl"
                  >Local Port Will Be Assigned</label
                >
              </div>
            </div>
          </div>

          <div class="row" *ngIf="showSpecialOptionsField(s.sourceType)">
            <label>Special Options</label>
            <div class="row-input">
              <input
                type="text"
                class="special-options"
                placeholder="Example: param1=value1&param2=value2"
                [(ngModel)]="s.specialOptions"
                [ngModelOptions]="{ standalone: true }"
              />
            </div>
          </div>

          <div class="row" *ngIf="showZixiRemoteNameField(s.sourceType)">
            <label>ZIXI REMOTE NAME</label>
            <div class="row-input">
              <input
                type="text"
                class="zixiRemoteName"
                placeholder="Type Zixi Remote Name"
                name="zixiRemoteName"
                [(ngModel)]="s.zixiRemoteName"
                required
                #zixiRemoteName="ngModel"
              />
              <div
                class="row-input-text error"
                *ngIf="
                  zixiRemoteName.invalid &&
                  (zixiRemoteName.dirty || zixiRemoteName.touched)
                "
              >
                Stream Name name is required
              </div>
            </div>
          </div>

          <div
            class="row az"
            *ngIf="showAddressPreview(s.sourceType) && getActivePlatform() as ap"
          >
            <label
              >{{ getAzDisplayName(ap.availabilityZoneId) }} ADDRESS:
            </label>
            <input
              type="text"
              readonly
              [value]="generateAddressPreview(ap.publicIp, s)"
            />
            <a
              class="btn btn-copy"
              (click)="
                copyToClipboard(
                  generateAddressPreview(ap.publicIp, s),
                  $event,
                  generateAddressPreview(ap.publicIp, s)
                )
              "
              >Copy</a
            >
          </div>
          </div>
          <div class="platform-preview">
            <button
              type="button"
              class="btn btn-export"
              *ngIf="!liveFeedPreview"
              [disabled]="!liveFeed.id"
              (click)="showPreview()"
            >
              SHOW PREVIEW
            </button>
            <icn-live-feed-preview
              *ngIf="!!liveFeedPreview"
              [liveFeedPreview]="liveFeedPreview"
            >
            </icn-live-feed-preview>
          </div>
        </section>
      </div>

      <icn-collapsible label="Metadata">
        <div class="metadata-container">
          <div>
            <ng-template
              ngFor
              let-item
              let-isEven="even"
              [ngForOf]="liveFeed.metadata"
            >
              <ichannel-input
                *ngIf="isEven"
                [label]="item.name"
                [value]="item.value"
                (output)="item.value = $event"
                placeholder="Add metadata"
              >
              </ichannel-input>
            </ng-template>
          </div>
          <div>
            <ng-template
              ngFor
              let-item
              let-isOdd="odd"
              [ngForOf]="liveFeed.metadata"
            >
              <ichannel-input
                *ngIf="isOdd"
                [label]="item.name"
                [value]="item.value"
                (output)="item.value = $event"
                placeholder="Add metadata"
              >
              </ichannel-input>
            </ng-template>
          </div>
        </div>
      </icn-collapsible>
      <icn-collapsible label="Tags">
        <autocomplete
          [position]="'top'"
          inputLabel="TAGS"
          inputPlaceholder="Add Tags"
          [feedWithEnter]="false"
          [values]="getAllTagNames()"
          [excludes]="getFeedTagNames()"
          (output)="addTag($event)"
          (outputNewValue)="createNewTag($event)"
        ></autocomplete>
        <tags-wrapper
          [tags]="getFeedTags()"
          (onDeleteTag)="deleteTag($event)"
        ></tags-wrapper>
      </icn-collapsible>
    </div>
  </form>
  <div class="submit-container">
    <a class="btn btn-export" (click)="saveLiveFeed()">Apply</a>
  </div>
</div>
<pop-over
  #encryptionPopover
  [my]="'left'"
  [at]="'right'"
  [anchor-to]="true"
  [x-offset]="15"
>
  <div class="encryption-popover" *ngIf="getActiveSettings() as s">
    <header>
      <span class="title">Enable Encryption</span>
      <div class="close-btn" (click)="encryptionPopover.hide()">
        <i class="fa fa-close"></i>
      </div>
    </header>
    <div class="input-group">
      <label>ENCRYPTION TYPE:</label>
      <icn-dropdown
        [selectedValue]="s.encryptionType"
        (selectedValueChange)="
          s.encryptionType = $event; s.encryptionKey = ''
        "
        [position]="'bottom'"
        [medium]="true"
      >
        <icn-dropdown-item [value]="1" [title]="'AES 128'"> </icn-dropdown-item>
        <icn-dropdown-item [value]="2" [title]="'AES 192'"> </icn-dropdown-item>
        <icn-dropdown-item [value]="3" [title]="'AES 256'"> </icn-dropdown-item>
      </icn-dropdown>
    </div>
    <div class="input-group">
      <label>ENCRYPTION KEY:</label>
      <textarea
        rows="5"
        [ngModel]="s.encryptionKey"
        (ngModelChange)="s.encryptionKey = $event"
      ></textarea>
    </div>
    <div class="footer-container">
      <a
        *ngIf="!s.encryptionKey"
        class="btn btn-copy btn-black"
        (click)="generateEncryptionKey(); $event.stopPropagation()"
        >Generate</a
      >
      <a
        *ngIf="!!s.encryptionKey"
        class="btn btn-copy btn-black"
        (click)="
          copyToClipboard(s.encryptionKey, $event, '');
          $event.stopPropagation()
        "
        >Copy</a
      >
    </div>
  </div>
</pop-over>
<pop-over
  #copiedPopover
  [my]="'bottom'"
  [at]="'top'"
  [anchor-to]="true"
  [y-offset]="10"
>
  <div class="copied-popover">Copied</div>
</pop-over>
<pop-over
  #infoPopover
  [my]="'left'"
  [at]="'right'"
  [anchor-to]="true"
  [x-offset]="10"
>
  <div class="info-popover">
    <div
      class="x-sign"
      inlineSVG="/assets/icons/x-close-pop.svg"
      (click)="infoPopover.hide(); $event.stopImmediatePropagation()"
    ></div>
    <div>
      Create a new stream ID, password, encryption key (if needed) and copy
      paste them into a new output at Zixi broadcaster/feeder
    </div>
  </div>
</pop-over>
